import { render, staticRenderFns } from "./paso1.vue?vue&type=template&id=2bc62527&scoped=true&"
import script from "./paso1.vue?vue&type=script&lang=ts&"
export * from "./paso1.vue?vue&type=script&lang=ts&"
import style0 from "./paso1.vue?vue&type=style&index=0&id=2bc62527&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc62527",
  null
  
)

export default component.exports